import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import toast from 'react-hot-toast';

export default function Login() {
  const { login } = useAuth();
  const { theme } = useTheme();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/dashboard');
    } catch (err) {
      toast.error('Invalid credentials. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: theme.gradient, padding: '1rem',
    }}>
      <div className="card animate-fade" style={{ width: '100%', maxWidth: '420px' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h1 style={{
            fontFamily: "'Rajdhani', sans-serif", fontSize: '2.5rem', fontWeight: 700,
            letterSpacing: '3px', background: `linear-gradient(135deg, ${theme.accent}, ${theme.success})`,
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          }}>VITALFORGE</h1>
          <p style={{ color: theme.textSecondary, fontSize: '0.85rem', letterSpacing: '1px' }}>
            YOUR HEALTH. FORGED DAILY.
          </p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: '0.5rem' }} disabled={loading}>
            {loading ? 'Signing in...' : '⚡ Sign In'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: '1.5rem', color: theme.textSecondary, fontSize: '0.85rem' }}>
          No account? <Link to="/signup" style={{ color: theme.accent }}>Create one free</Link>
        </p>
      </div>
    </div>
  );
}
